"use client";

import React, { useState } from "react";
import styles from "../styles/sidebar-section.module.scss";
import Image from "next/image";
import arrowUp from "@/assets/sidebar/arrow-up.svg";
import arrowDown from "@/assets/sidebar/arrow-down.svg";
import SidebarSectionItem from "@/components/sidebar/sidebar-components/sidebar-section-item";
import SidebarItemSoon from "@/components/sidebar/sidebar-components/sidebar-item-soon";
import { SectionItem } from "@/components/sidebar/models/section-item";
import { usePathname } from "next/navigation";

type SidebarSectionWithItemsProps = {
  image: string;
  title: string;
  items: SectionItem[];
  isOpen?: boolean;
};

const SidebarSectionWithItems = ({
  image,
  title,
  items,
  isOpen,
}: SidebarSectionWithItemsProps) => {
  const [isSectionOpen, setIsSectionOpen] = useState<boolean | undefined>(
    isOpen,
  );

  const pathname = usePathname();

  const handleClick = () => {
    setIsSectionOpen(!isSectionOpen);
  };

  return (
    <div className={styles.section}>
      <div
        className={
          isSectionOpen ? styles.dropdown_opened : styles.dropdown_header
        }
        onClick={handleClick}
        role="button"
      >
        <div className={styles.content_wrapper}>
          <div className={styles.main}>
            <Image className={styles.section_image} src={image} alt={title} />
            <div className={styles.section_title}>{title}</div>
          </div>
          <Image
            className={styles.arrow}
            src={isSectionOpen ? arrowUp : arrowDown}
            alt="dropdown"
          />
        </div>
      </div>
      {isSectionOpen && (
        <div className={styles.items_wrapper}>
          {items.map((item, index) => {
            const isSelected = pathname.startsWith(item.href);
            return item.soon ? (
              <SidebarItemSoon key={index} title={item.title} />
            ) : (
              <SidebarSectionItem
                key={index}
                title={item.title}
                href={item.href}
                hrefTarget={item.hrefTarget}
                isSelected={isSelected}
                onClick={item.onClick}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SidebarSectionWithItems;
